import { TwcaMidLib } from './idpaas/mid';
import { TwcaCertLib } from './idpaas/cert';
import { TwcaVerifyLib } from './idpaas/verify';
import { TwcaAtlAgentLib } from './idpaas/atl-agent';
import packageJson from '../package.json';

// pre-expose old name
window.twcaMidLibSS = new TwcaMidLib();
window.twcaCertLibSS = new TwcaCertLib();
window.twcaVerifyLibSS = new TwcaVerifyLib();
window.twcaAtlAgentLibSS = new TwcaAtlAgentLib();

// pre-expose old old name
window.twcaIDPaaSTwdsLib = new TwcaCertLib();

export default {
  TwcaIDPaaSLib: {
    version: packageJson.version,
    Mid: TwcaMidLib,
    Cert: TwcaCertLib,
    Verify: TwcaVerifyLib,
    AtlAgent: TwcaAtlAgentLib
  }
};
